import { lazy, Suspense, useEffect } from "react";
import { useConnection } from "wagmi";
import { TopBar } from "./layout/TopBar";
import { Sheets } from "./layout/Sheets";
import { SigningSheet, Toaster } from "./layout/Overlays";
import { MomentHost } from "./layout/Moment";
import { useRoute } from "./router";
import { follow, refreshAccount } from "./state/account";
import { startAccountEvents } from "./state/actions";
import { useMarkFeed, useTradingState, useWinFee } from "./state/market";
import { useTickRecorder } from "./state/ticks";
import { useValuationFeed } from "./state/valuation";
import { Play } from "./views/play/Play";

const Bankroll = lazy(() => import("./views/bankroll/Bankroll").then((m) => ({ default: m.Bankroll })));
const Floor = lazy(() => import("./views/floor/Stats").then((m) => ({ default: m.Stats })));

/** What runs once for the page: the markets, the marks, the account and its valuations. */
function useVenue() {
  const trading = useTradingState();
  useMarkFeed(trading.data);
  useTickRecorder();
  useWinFee();
  useValuationFeed();

  // claimable rewards move with the trading state's accumulator
  useEffect(() => {
    if (trading.data) refreshAccount();
  }, [trading.data]);

  const { address, status } = useConnection();
  useEffect(() => {
    if (status === "connected" && address) follow(address);
    else if (status === "disconnected") follow(null);
  }, [address, status]);

  useEffect(() => startAccountEvents(), []);
}

export function App() {
  const route = useRoute();
  useVenue();
  return (
    <div className="app">
      <TopBar route={route} />
      <Suspense fallback={<div className="page-loading" />}>
        {route.view === "play" && <Play coin={route.coin} />}
        {route.view === "bankroll" && <Bankroll />}
        {route.view === "floor" && <Floor />}
      </Suspense>
      <Sheets />
      <MomentHost />
      <Toaster />
      <SigningSheet />
    </div>
  );
}
